<template>
  <div class="heures-services-view">
    <Header title="Gestion des heures de services" />
    
    <div class="content-container">
      <div class="content-header">
        <h2>Configuration des heures de services</h2>
        <p class="description">
          Définissez les horaires de travail pour chaque jour de la semaine, les pauses et les tolérances de retard.
        </p>
      </div>
      
      <div class="main-content">
        <HeuresServicesForm 
          :loading="loading"
          @success="handleSuccess"
        />
      </div>
    </div>
    
    <!-- Notification toast -->
    <NotificationToast 
      v-if="notification.show"
      :type="notification.type"
      :title="notification.title"
      :message="notification.message"
      :duration="notification.duration"
      @close="notification.show = false"
    />
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import Header from '../components/Header.vue';
import HeuresServicesForm from '../components/parametres/HeuresServicesForm.vue';
import NotificationToast from '../components/NotificationToast.vue';

// Variables réactives
const loading = ref(false);

// Configuration des notifications
const notification = reactive({
  show: false,
  type: 'info',
  title: 'Notification',
  message: '',
  duration: 3000
});

// Gérer les événements de succès du formulaire
function handleSuccess(data) {
  notification.type = data.type || 'success';
  notification.title = data.title || 'Succès';
  notification.message = data.message;
  notification.show = true;
}
</script>

<style scoped>
.heures-services-view {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.content-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.content-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.content-header h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 8px;
}

.description {
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

.main-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}
</style>
